import { get } from 'lodash'
import moment from 'moment'
import React from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { ArrowClockwise } from 'react-bootstrap-icons'
import useViewport from '../../../hooks/use-viewport'

const SeriesLabel = ({
    experience = {}
}) => {
    const { breakpoint, breakpoints } = useViewport()
    const dateFormat = 'MM/DD/YYYY'
    const { startDate, endDate } = get(experience, 'series', {})
    const startLabel = moment(startDate).isValid() ? moment(startDate).format(dateFormat) : '?'
    const endLabel = moment(endDate).isValid() ? moment(endDate).format(dateFormat) : '?'
    return (
        <Form.Group as={Row}>
            <Form.Label column sm={12} md={1} lg={2} xl={3}>
                <ArrowClockwise size={30} /> {breakpoint >= breakpoints.XL || breakpoint <= breakpoints.SM ? 'Series' : ''}
            </Form.Label>
            <Col sm={12} md={11} lg={10} xl={3} style={{ display: 'flex', justifyContent: 'row', alignContent: 'center', alignItems: 'center'}}>
                {startLabel} - {endLabel}
            </Col>
        </Form.Group>
    )
}

export default SeriesLabel
